import Layout from "@/components/elements/Layout";
import UserContentTypes from "@/components/settings/UserContentTypes";
import UserPreferences from "@/components/settings/UserPreferences";
import useAuth from "@/hooks/auth";

export default function Settings() {
  const { user } = useAuth({ middleware: "auth" });

  return (
    <Layout title={"Settings"}>
      <div className='max-w-6xl px-4 mx-auto 2xl:max-w-7xl'>
        <h1 className='pt-8 text-6xl font-bold leading-tight text-white font-display'>
          Preferences
        </h1>
        <h2 className='text-white text-opacity-80'>
          Change your preferences below
        </h2>
        <div className='py-8'>
          <UserPreferences />
        </div>
        <div className='py-8'>
          <UserContentTypes />
        </div>
      </div>
      <style jsx>
        {`
          .topic-references label:before {
            content: "";
            z-index: 100;
          }
          .topic-references :checked + label:before {
            content: "";
            opacity: 1;
          }
          .topic-references input[type="checkbox"] {
            display: none;
            cursor: pointer;
          }
          .topic-references :checked + label > div {
            opacity: 1;
          }
          .topic-references label > div {
            opacity: 0.8;
            transition: 0.3s all ease-out;
          }
          .topic-references .checkmark {
            opacity: 0;
          }
          .topic-references :checked + label .checkmark {
            transition: 0.3s all ease-out;
            opacity: 1;
          }
          .topic-references .selected-border {
            border: 1px solid white;
          }
          .topic-references :checked + label .selected-border {
            border: 1px solid white;
          }
        `}
      </style>
    </Layout>
  );
}
